export default __webpack_public_path__ + "static/media/dustbin.69b0fab1.svg";